import { Role } from 'common-billing-server/types'

const externalRoleLabels: Partial<Record<Role, string>> = {
    [Role.external]: 'admin',
    [Role.externalBasic]: 'basic',
}

export const formatExternalRole = (role: Role): string => externalRoleLabels[role] ?? role
